<div class="acd">
  <div class="acd-header">
    <div class="acd-header-text">
      <p class="acd-eyebrow">Timesheet · Period</p>
      <h2 class="acd-heading">Absence insight</h2>
      <p class="acd-range">{{ data.rangeLabel }}</p>
      <p class="acd-hint">{{ hint }}</p>
    </div>
    <button type="button" class="acd-close" mat-dialog-close aria-label="Close dialog">
      <mat-icon fontSet="material-icons-outlined">close</mat-icon>
    </button>
  </div>

  <div class="acd-filters">
    <label class="acd-filter">
      <span class="acd-filter-label">Team</span>
      <select class="acd-select" [(ngModel)]="filterTeamId" (ngModelChange)="onScopeFilterChange()">
        <option [ngValue]="null">All teams</option>
        <option *ngFor="let team of teamList" [ngValue]="team?.id">{{ teamLabel(team) }}</option>
      </select>
    </label>
    <label class="acd-filter">
      <span class="acd-filter-label">Shift</span>
      <select class="acd-select" [(ngModel)]="filterShiftId" (ngModelChange)="onScopeFilterChange()">
        <option [ngValue]="null">All shifts</option>
        <option *ngFor="let shift of shiftList" [ngValue]="shift.id">{{ shiftLabel(shift) }}</option>
      </select>
    </label>
    <label class="acd-filter">
      <span class="acd-filter-label">Employee</span>
      <select class="acd-select" [(ngModel)]="filterEmployeeId" (ngModelChange)="onViewFilterChange()">
        <option [ngValue]="null">All employees</option>
        <option *ngFor="let emp of employeeOptions" [ngValue]="emp.id">{{ emp.name }}</option>
      </select>
    </label>
    <label class="acd-filter">
      <span class="acd-filter-label">Show</span>
      <select class="acd-select" [(ngModel)]="filterFocus" (ngModelChange)="onViewFilterChange()">
        <option value="all">All days</option>
        <option value="absent">Days with absence</option>
        <option value="present">Days with scheduled present</option>
        <option value="ot">Days with off-shift / OT</option>
      </select>
    </label>
    <button type="button" class="acd-filter-clear" (click)="clearFilters()" [disabled]="loading">Clear</button>
  </div>

  <div class="acd-toolbar" *ngIf="absenceSummary && !loading">
    <div class="acd-stat acd-stat--ok">
      <span class="acd-stat-value">{{ absenceSummary.employees_with_presence || 0 }}</span>
      <span class="acd-stat-label">with presence</span>
    </div>
    <div class="acd-stat acd-stat--ok">
      <span class="acd-stat-value">{{ absenceSummary.total_present_days || 0 }}</span>
      <span class="acd-stat-label">present events</span>
    </div>
    <div class="acd-stat">
      <span class="acd-stat-value">{{ absenceSummary.employees_with_absence || 0 }}</span>
      <span class="acd-stat-label">with absence</span>
    </div>
    <div class="acd-stat">
      <span class="acd-stat-value">{{ absenceSummary.total_absent_days || 0 }}</span>
      <span class="acd-stat-label">absence events</span>
    </div>
    <div class="acd-stat acd-stat--extra">
      <span class="acd-stat-value">{{ absenceSummary.total_off_schedule_events || 0 }}</span>
      <span class="acd-stat-label">off-shift / OT</span>
    </div>
    <div class="acd-legend">
      <span class="acd-legend-item"><i class="acd-dot acd-dot--absent"></i>Absent</span>
      <span class="acd-legend-item"><i class="acd-dot acd-dot--ok"></i>Present (scheduled)</span>
      <span class="acd-legend-item"><i class="acd-dot acd-dot--extra"></i>Off-shift / overtime</span>
      <span class="acd-legend-item"><i class="acd-dot acd-dot--off"></i>No scheduled work</span>
    </div>
  </div>

  <div class="acd-body">
    <div *ngIf="loading" class="acd-skeleton">
      <ngx-skeleton-loader count="3" [theme]="{ 'border-radius': '12px', height: '100px', width: '100%' }"></ngx-skeleton-loader>
    </div>

    <div *ngIf="!loading" class="acd-grid">
      <div
        class="acd-cell"
        *ngFor="let day of absenceDays"
        [class.acd-cell--muted]="isAbsenceNoScheduledWorkDay(day)"
        [class.acd-cell--has-absent]="day.absent_count > 0">
        <div class="acd-cell-head">
          <span class="acd-cell-date">{{ datePipe.transform(day.date, 'EEE d MMM') }}</span>
          <div class="acd-cell-badges">
            <span class="acd-badge acd-badge--absent" *ngIf="day.absent_count" title="Absent">{{ day.absent_count }}</span>
            <span class="acd-badge acd-badge--ok" *ngIf="presentCount(day)" title="Present on scheduled day">{{ presentCount(day) }}</span>
            <span class="acd-badge acd-badge--extra" *ngIf="offScheduleCount(day)" title="Off-shift / overtime">{{ offScheduleCount(day) }}</span>
          </div>
        </div>

        <div class="acd-cell-block" *ngIf="day.absent_count > 0">
          <p class="acd-cell-label">Absent</p>
          <div
            class="acd-chips"
            [class.acd-chips--scroll]="isAbsenceDayExpanded(day) && (day.absent_employees || []).length > absencePreviewLimit">
            <button type="button" class="acd-chip acd-chip--absent" *ngFor="let emp of absenceEmployeesForDisplay(day)" (click)="selectAbsencePill(day, emp)">
              {{ emp.name }}
            </button>
            <button
              type="button"
              class="acd-chip acd-chip--more"
              *ngIf="absenceHiddenCount(day) > 0 && !isAbsenceDayExpanded(day)"
              (click)="toggleAbsenceDayExpand(day, $event)">
              +{{ absenceHiddenCount(day) }} more
            </button>
            <button
              type="button"
              class="acd-link"
              *ngIf="isAbsenceDayExpanded(day) && (day.absent_employees || []).length > absencePreviewLimit"
              (click)="toggleAbsenceDayExpand(day, $event)">
              Show less
            </button>
          </div>
        </div>

        <div class="acd-cell-block" *ngIf="presentCount(day) > 0" [class.acd-cell-block--split]="day.absent_count > 0">
          <p class="acd-cell-label acd-cell-label--ok">Present (scheduled)</p>
          <div class="acd-chips">
            <button type="button" class="acd-chip acd-chip--ok" *ngFor="let emp of (day.present_employees || [])" (click)="selectAbsencePill(day, emp)">
              {{ emp.name }}
            </button>
          </div>
        </div>

        <div class="acd-cell-block" *ngIf="offScheduleCount(day) > 0" [class.acd-cell-block--split]="day.absent_count > 0 || presentCount(day) > 0">
          <p class="acd-cell-label acd-cell-label--extra">Off-shift / overtime</p>
          <div class="acd-chips">
            <button type="button" class="acd-chip acd-chip--extra" *ngFor="let row of (day.off_schedule_employees || [])" (click)="selectOffSchedulePill(day, row)">
              {{ row.name }}
            </button>
          </div>
        </div>

        <div class="acd-status" *ngIf="isAbsenceAllPresentDay(day) && presentCount(day) === 0">
          <mat-icon fontSet="material-icons-outlined" class="acd-status-icon acd-status-icon--ok">check_circle</mat-icon>
          <span>All scheduled present</span>
          <span class="acd-status-meta" *ngIf="absenceScheduledCount(day) as n">{{ n }} scheduled</span>
        </div>
        <div class="acd-status" *ngIf="isAbsenceNoScheduledWorkDay(day)">
          <mat-icon fontSet="material-icons-outlined" class="acd-status-icon acd-status-icon--off">bedtime</mat-icon>
          <span>No scheduled work</span>
        </div>
      </div>
    </div>
  </div>

  <div class="acd-footer" *ngIf="selectedAbsenceDetail">
    <div class="acd-footer-text">
      <span class="acd-footer-name">{{ selectedAbsenceDetail.name }}</span>
      <span class="acd-footer-line">{{ datePipe.transform(selectedAbsenceDetail.date, 'dd MMM yyyy') }} · {{ selectedAbsenceDetail.reason || '—' }}</span>
      <span class="acd-footer-line">Shift · {{ selectedAbsenceDetail.shift_name || '—' }}</span>
    </div>
    <button type="button" class="acd-primary" (click)="openUserWiseFromDetail()">Open user-wise timesheet</button>
  </div>
</div>
